import cn from 'clsx';
import SearchForm from '@v2/shared/components/SearchForm';
import { SearchBarState } from '@v2/shared/lib/types';
import { forwardRef, Ref } from 'react';
import { SearchAutoCompleteProps } from '@v2/shared/lib/useSearchAutoComplete';

type Props = {
  isOpen: boolean;
  className?: string;
  searchBarState: SearchBarState;
  searchAutoCompleteProps: SearchAutoCompleteProps;
  /** Passed through to SearchForm; the sale page scopes its wording to the promotion. */
  placeholder?: string;
};

function SearchBar(
  { isOpen, className, searchBarState, searchAutoCompleteProps, placeholder }: Props,
  ref: Ref<HTMLInputElement>
) {
  return (
    <div
      className={cn('pt-0 pb-3 px-3 lg:hidden', className, {
        hidden: !isOpen,
      })}
    >
      <div className="flex w-full group relative">
        <SearchForm
          id="global-search-mobile"
          searchBarState={searchBarState}
          searchAutoCompleteProps={searchAutoCompleteProps}
          placeholder={placeholder}
          ref={ref}
        />
      </div>
    </div>
  );
}

export default forwardRef(SearchBar);
